/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteTaskProgressCommand } from '../../models/delete-task-progress-command';
import { DeleteTaskProgressCommandResult } from '../../models/delete-task-progress-command-result';

export interface ApiTaskProgressDeleteTaskProgressDelete$Plain$Params {
      body?: DeleteTaskProgressCommand
}

export function apiTaskProgressDeleteTaskProgressDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskProgressDeleteTaskProgressDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteTaskProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskProgressDeleteTaskProgressDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteTaskProgressCommandResult>;
    })
  );
}

apiTaskProgressDeleteTaskProgressDelete$Plain.PATH = '/api/TaskProgress/DeleteTaskProgress';
